// @flow
import { Button, Divider } from "@mui/material";
import * as React from "react";
import { useTranslation } from "next-i18next";
import Script from "next/script";
import Link from "next/link";
import { useRouter } from "next/router";
import Image from "next/image";
import Socials from "../../components/Socials";

export const Footer = (props) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const { locale } = useRouter();
  return (
    <>
      <Script id="1sdipauohncdspm44h6pssgn5m">
        {`    var EhAPI = EhAPI || { }; EhAPI.after_load = function(){
                    EhAPI.set_account('1sdipauohncdspm44h6pssgn5m', 'coimex');
EhAPI.execute('rules');};(function(d,s,f) {
var sc=document.createElement(s);sc.type='text/javascript';
                sc.async=true;sc.src=f;var m=document.getElementsByTagName(s)[0];
                m.parentNode.insertBefore(sc,m);
})(document, 'script', '//d2p078bqz5urf7.cloudfront.net/jsapi/ehform.js?v' + new Date().getHours());
`}
      </Script>
      <div className="bg-PrimaryB bottom-0  w-full flex flex-col  pt-[55px]">
        <div className="  flex flex-col  w-11/12 mx-auto md:flex-row justify-start">
          <div className="w-[296px]">
            <h2 className="text-base font-MontserratSemiBold text-textColor">
              {t("Footer.0")}
            </h2>
            <p className="pt-[17px] text-base font-montserrat text-textColor">
              {t("Footer.1")}
            </p>
            {/* <div id="eh_form_5458293877637120" data-id="5458293877637120" className="bg-white  h-10 mt-8 flex items-center flex-row-reverse justify-around"> */}
            {/* <Button onClick={() => sendEmailToEngagebay()} className=" border-2 w-[108px] text-white h-8  bg-fontColorB  font-MontserratMedium text-xs">
                                {t("Footer.3")}
                            </Button>
                            <input placeholder={t("Footer.2")} className="font-montserrat h-full w-7/12 outline-none p-4" type="text" /> */}
            {/* </div> */}
            {lang !== "tr" ? (
              <div
                className="engage-hub-form-embed"
                id="eh_form_4661158118686720"
                data-id="4661158118686720"
              ></div>
            ) : (
              <div
                className="engage-hub-form-embed"
                id="eh_form_6185008938614784"
                data-id="6185008938614784"
              ></div>
            )}
          </div>

          <div className="pt-8 md:pt-0 md:pl-[12%]">
            <h2 className="text-base font-MontserratSemiBold text-textColor">
              {t("Footer.4")}
            </h2>
            <a
              href="tel:+16035257066"
              className="pt-[17px] block text-base font-montserrat  text-textColor"
            >
              + 1 (603) 525 - 70 66
            </a>
            <div className="flex items-center">
              <Svgwahstapp />
              <a
                href="https://wa.me/905324479299"
                className="pt-[9px] block text-base font-montserrat text-textColor"
              >
                +90 (532) 447 - 92 99
              </a>
            </div>

            <div className=" md:flex flex-col items-center md:pr-[10px] hidden">
              <h2 className="pt-14  text-base font-MontserratSemiBold text-textColor">
                {t("Footer.10")}
              </h2>
              <div className="pt-3 flex md:justify-start justify-around md:w-full  w-3/6">
                <a
                  aria-label="youtube"
                  href={
                    lang === "tr"
                      ? "https://www.youtube.com/@coimexglobal"
                      : "https://www.youtube.com/@coimexglobal"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <Svgyoutube />
                </a>
                <a
                  aria-label="twitter"
                  href={
                    lang === "tr"
                      ? "https://twitter.com/CoimexTurkiye"
                      : "https://twitter.com/CoimexGlobal"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <SvgTwiter />
                </a>
                <a
                  aria-label="instagram"
                  href={
                    lang === "tr"
                      ? "https://www.instagram.com/coimexturkiye/"
                      : "https://www.instagram.com/coimexglobal/"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <SvgInsta />
                </a>
                <a
                  aria-label="facebook"
                  href="https://www.facebook.com/coimexturkiye"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <SvgFacebook />
                </a>
              </div>
            </div>
          </div>

          <div className="md:pl-[18%]">
            <div className="flex flex-col  md:pr-[10px] ">
              <h2 className="pt-8 md:pt-0 text-base font-MontserratSemiBold text-textColor">
                {t("Footer.5")}
              </h2>

              <Link href={"/importer-platform"} locale={locale}>
                <a {...props}>
                  <p className="pt-[9px] cursor-pointer text-base font-montserrat text-textColor">
                    {t("Footer.6")}
                  </p>
                </a>
              </Link>
              <Link href={"/exporter-platform"} locale={locale}>
                <a {...props}>
                  <p className="pt-[9px] cursor-pointer text-base font-montserrat text-textColor">
                    {t("Footer.7")}
                  </p>
                </a>
              </Link>
              <Link href={"/pricing"} locale={locale}>
                <a {...props}>
                  <p className="pt-[9px] cursor-pointer text-base font-montserrat text-textColor">
                    {t("Footer.8")}
                  </p>
                </a>
              </Link>
              <Link href={"/faq"} locale={locale}>
                <a {...props}>
                  <p className="pt-[9px] text-base cursor-pointer font-montserrat text-textColor">
                    {t("Footer.9")}
                  </p>
                </a>
              </Link>
            </div>

            {/* Audit report certificate */}
            <div className="mt-4 p-2 w-[300px] border-2 border-solid border-textColor rounded-md">
              <p className="text-base font-MontserratSemiBold text-textColor mb-2">
                {" "}
                {t("Footer.15")}
              </p>
              <div className="flex items-center justify-center">
                <Link href={"https://app.solidproof.io/projects/eximtoken"}>
                  <a target="_blank" rel="noopener noreferrer">
                    <Image
                      src="/images/solidProof_logo.png"
                      alt="Solidproof Audit Report"
                      width={200}
                      height={50}
                    />
                  </a>
                </Link>
              </div>
            </div>
          </div>
          <div className=" flex flex-col items-center md:pr-[10px] md:hidden">
            <h2 className="pt-14  text-base font-MontserratSemiBold text-textColor">
              {t("Footer.10")}
            </h2>
            <Socials />
          </div>
        </div>

        <Divider
          style={{ height: 1, backgroundColor: "#FFFBFE" }}
          className="text-textColor flex mt-14 w-full"
        />
        <div className="md:w-full flex flex-col  items-center">
          <div className="pt-6 md:pb-6 flex justify-center  items-center w-full md:w-4/6 gap-1">
            <h2 className="pr-1 text-xs font-montserrat text-textColor">
              2022 - 2023
            </h2>

            <SvgVector />
            <h2 className="pl-1 text-xs font-montserrat text-textColor">
              {t("Footer.14")}
            </h2>
          </div>

          <div className=" pb-6 flex items-center md:pt-0 pt-4 justify-around w-5/6 md:w-2/6 ">
            <Link href={"/privacy-policy"} locale={locale}>
              <a {...props}>
                <p className="cursor-pointer text-xs font-montserrat text-textColor">
                  {t("Footer.11")}
                </p>
              </a>
            </Link>
            <Link href={"/terms-of-use"} locale={locale}>
              <a {...props}>
                <p className="cursor-pointer text-xs font-montserrat text-textColor">
                  {t("Footer.12")}
                </p>
              </a>
            </Link>
            <Link href={"/user-agreement"} locale={locale}>
              <a {...props}>
                <p className="cursor-pointer text-xs font-montserrat text-textColor">
                  {t("Footer.13")}
                </p>
              </a>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

const Svgyoutube = () => (
  <svg
    className="md:mr-2"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9241 11.7996L11.2289 10.542C10.9937 10.4328 10.8005 10.5552 10.8005 10.8156V13.1844C10.8005 13.4448 10.9937 13.5672 11.2289 13.458L13.9229 12.2004C14.1593 12.09 14.1593 11.91 13.9241 11.7996ZM12.0005 0.47998C5.63807 0.47998 0.480469 5.63758 0.480469 12C0.480469 18.3624 5.63807 23.52 12.0005 23.52C18.3629 23.52 23.5205 18.3624 23.5205 12C23.5205 5.63758 18.3629 0.47998 12.0005 0.47998ZM12.0005 16.68C6.10367 16.68 6.00047 16.1484 6.00047 12C6.00047 7.85158 6.10367 7.31998 12.0005 7.31998C17.8973 7.31998 18.0005 7.85158 18.0005 12C18.0005 16.1484 17.8973 16.68 12.0005 16.68Z"
      fill="#FFFBFE"
    />
  </svg>
);
const SvgTwiter = ({ color }) => (
  <svg
    className="md:mr-2"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.625 24 24 18.6289 24 12C24 5.37109 18.625 0 12 0C5.375 0 0 5.37109 0 12C0 14.9453 1.0625 17.6406 2.82031 19.7266C5.02344 22.3398 8.32031 24 12 24ZM18.1719 6H16.0234L12.4844 10.043L9.42969 6H5L10.2969 12.9219L5.27344 18.6523H7.42188L11.2969 14.2305L14.6797 18.6523H19L13.4844 11.3594L18.1719 6ZM16.4609 17.3711H15.2734L7.50781 7.21875H8.78125L16.4609 17.3711Z"
      fill={color ? color : "#FFFBFE"}
    />
  </svg>
);

const SvgInsta = () => (
  <svg
    className="md:mr-2"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6005 12C15.6005 12.9548 15.2212 13.8704 14.5461 14.5456C13.8709 15.2207 12.9552 15.6 12.0005 15.6C11.0457 15.6 10.13 15.2207 9.45488 14.5456C8.77975 13.8704 8.40047 12.9548 8.40047 12C8.40047 11.7948 8.42207 11.5944 8.45927 11.4H7.20047V16.1964C7.20047 16.53 7.47047 16.8 7.80407 16.8H16.1981C16.3579 16.7997 16.5112 16.7359 16.6241 16.6228C16.737 16.5096 16.8005 16.3563 16.8005 16.1964V11.4H15.5417C15.5789 11.5944 15.6005 11.7948 15.6005 12ZM12.0005 14.4C12.3157 14.3999 12.6279 14.3377 12.9191 14.217C13.2103 14.0963 13.4749 13.9194 13.6978 13.6964C13.9206 13.4735 14.0974 13.2088 14.218 12.9175C14.3385 12.6262 14.4005 12.314 14.4005 11.9988C14.4004 11.6835 14.3382 11.3714 14.2175 11.0802C14.0968 10.7889 13.9199 10.5243 13.6969 10.3015C13.474 10.0786 13.2093 9.90185 12.918 9.78129C12.6267 9.66072 12.3145 9.5987 11.9993 9.59878C11.3626 9.59894 10.7521 9.85201 10.302 10.3023C9.85188 10.7526 9.59911 11.3633 9.59927 12C9.59943 12.6367 9.8525 13.2472 10.3028 13.6973C10.7531 14.1474 11.3638 14.4001 12.0005 14.4ZM14.8805 9.47998H16.3193C16.4149 9.47998 16.5065 9.44209 16.5743 9.37461C16.642 9.30713 16.6802 9.21557 16.6805 9.11998V7.68118C16.6805 7.58538 16.6424 7.49351 16.5747 7.42577C16.5069 7.35804 16.4151 7.31998 16.3193 7.31998H14.8805C14.7847 7.31998 14.6928 7.35804 14.6251 7.42577C14.5573 7.49351 14.5193 7.58538 14.5193 7.68118V9.11998C14.5205 9.31798 14.6825 9.47998 14.8805 9.47998ZM12.0005 0.47998C8.94518 0.47998 6.01502 1.69369 3.8546 3.85411C1.69418 6.01453 0.480469 8.94469 0.480469 12C0.480469 15.0553 1.69418 17.9854 3.8546 20.1459C6.01502 22.3063 8.94518 23.52 12.0005 23.52C13.5133 23.52 15.0113 23.222 16.409 22.6431C17.8067 22.0641 19.0766 21.2156 20.1463 20.1459C21.2161 19.0761 22.0646 17.8062 22.6436 16.4085C23.2225 15.0108 23.5205 13.5128 23.5205 12C23.5205 10.4872 23.2225 8.98914 22.6436 7.59147C22.0646 6.1938 21.2161 4.92384 20.1463 3.85411C19.0766 2.78438 17.8067 1.93582 16.409 1.35689C15.0113 0.777954 13.5133 0.47998 12.0005 0.47998ZM18.0005 16.6668C18.0005 17.4 17.4005 18 16.6673 18H7.33367C6.60047 18 6.00047 17.4 6.00047 16.6668V7.33318C6.00047 6.59998 6.60047 5.99998 7.33367 5.99998H16.6673C17.4005 5.99998 18.0005 6.59998 18.0005 7.33318V16.6668Z"
      fill="#FFFBFE"
    />
  </svg>
);

const SvgFacebook = () => (
  <svg
    className="md:mr-2"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C5.3725 0 0 5.3725 0 12C0 18.6275 5.3725 24 12 24C18.6275 24 24 18.6275 24 12C24 5.3725 18.6275 0 12 0ZM14.8425 8.2925H13.0388C12.825 8.2925 12.5875 8.57375 12.5875 8.9475V10.25H14.8438L14.5025 12.1075H12.5875V17.6838H10.4588V12.1075H8.5275V10.25H10.4588V9.1575C10.4588 7.59 11.5463 6.31625 13.0388 6.31625H14.8425V8.2925Z"
      fill="#FFFBFE"
    />
  </svg>
);

const SvgVector = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346614 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9959 5.87954 15.1517 3.84712 13.6523 2.34772C12.1529 0.848331 10.1205 0.00414558 8 0ZM8 15.0588C6.6039 15.0588 5.23915 14.6448 4.07833 13.8692C2.91751 13.0936 2.01277 11.9911 1.4785 10.7013C0.944235 9.41146 0.804447 7.99217 1.07681 6.62289C1.34918 5.25361 2.02147 3.99585 3.00866 3.00866C3.99585 2.02146 5.25362 1.34918 6.62289 1.07681C7.99217 0.804443 9.41146 0.944232 10.7013 1.4785C11.9911 2.01276 13.0936 2.91751 13.8692 4.07833C14.6448 5.23914 15.0588 6.6039 15.0588 8C15.0567 9.87148 14.3124 11.6657 12.989 12.989C11.6657 14.3124 9.87148 15.0567 8 15.0588ZM5.33334 8C5.33334 8.55968 5.50944 9.10518 5.83669 9.55922C6.16394 10.0133 6.62576 10.3528 7.15673 10.5298C7.68769 10.7068 8.26089 10.7122 8.79511 10.5454C9.32934 10.3785 9.79752 10.0477 10.1333 9.6C10.2082 9.50015 10.3197 9.43414 10.4433 9.41649C10.5668 9.39884 10.6923 9.43099 10.7922 9.50588C10.892 9.58076 10.958 9.69225 10.9757 9.8158C10.9933 9.93935 10.9612 10.0649 10.8863 10.1647C10.4319 10.7705 9.79852 11.218 9.07574 11.4437C8.35296 11.6695 7.57747 11.6622 6.8591 11.4227C6.14074 11.1832 5.51592 10.7238 5.07317 10.1095C4.63041 9.49525 4.39216 8.75722 4.39216 8C4.39216 7.24277 4.63041 6.50475 5.07317 5.89046C5.51592 5.27616 6.14074 4.81675 6.8591 4.5773C7.57747 4.33784 8.35296 4.33048 9.07574 4.55626C9.79852 4.78204 10.4319 5.22951 10.8863 5.83529C10.9234 5.88473 10.9503 5.94099 10.9657 6.00085C10.981 6.06072 10.9844 6.12302 10.9757 6.1842C10.9669 6.24537 10.9462 6.30423 10.9147 6.35741C10.8832 6.41058 10.8416 6.45704 10.7922 6.49412C10.7427 6.5312 10.6865 6.55817 10.6266 6.57351C10.5667 6.58885 10.5044 6.59224 10.4433 6.5835C10.3821 6.57476 10.3232 6.55406 10.27 6.52257C10.2169 6.49109 10.1704 6.44944 10.1333 6.4C9.79752 5.95225 9.32934 5.62151 8.79511 5.45463C8.26089 5.28775 7.68769 5.29319 7.15673 5.47018C6.62576 5.64716 6.16394 5.98673 5.83669 6.44077C5.50944 6.89481 5.33334 7.44031 5.33334 8Z"
      fill="#FFFBFE"
    />
  </svg>
);

const Svgwahstapp = () => (
  <svg
    className="mt-2 mr-2"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#FFFBFE" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.5C7.85775 4.5 4.5 7.85775 4.5 12C4.5 13.4175 4.89375 14.745 5.5785 15.876L4.9095 18.15C4.87109 18.2806 4.86856 18.4191 4.90218 18.5509C4.93581 18.6828 5.00434 18.8032 5.10057 18.8994C5.1968 18.9957 5.31719 19.0642 5.44906 19.0978C5.58094 19.1314 5.71944 19.1289 5.85 19.0905L8.124 18.4215C9.29301 19.1288 10.6337 19.5019 12 19.5C16.1423 19.5 19.5 16.1423 19.5 12C19.5 7.85775 16.1423 4.5 12 4.5ZM10.3035 13.6973C11.8207 15.2138 13.269 15.414 13.7805 15.4328C14.5582 15.4613 15.3157 14.8673 15.6105 14.178C15.6477 14.0923 15.6612 13.9981 15.6496 13.9053C15.638 13.8126 15.6017 13.7247 15.5445 13.6508C15.1335 13.1258 14.5778 12.7485 14.0347 12.3735C13.9214 12.2951 13.7821 12.2637 13.646 12.2858C13.51 12.3079 13.3877 12.3818 13.305 12.492L12.855 13.1783C12.8313 13.2151 12.7945 13.2416 12.7519 13.2522C12.7094 13.2628 12.6645 13.2567 12.6263 13.2353C12.321 13.0605 11.8763 12.7635 11.5568 12.444C11.2373 12.1245 10.9583 11.7 10.8015 11.4143C10.7821 11.3779 10.7764 11.3358 10.7857 11.2957C10.7949 11.2556 10.8184 11.2202 10.8517 11.196L11.5447 10.6815C11.6436 10.5955 11.7075 10.4761 11.7241 10.3461C11.7407 10.2161 11.7089 10.0846 11.6347 9.9765C11.2987 9.4845 10.9073 8.859 10.3395 8.44425C10.2662 8.39115 10.1804 8.35805 10.0904 8.34818C10.0005 8.33832 9.90954 8.35204 9.8265 8.388C9.1365 8.6835 8.5395 9.441 8.568 10.2203C8.58675 10.7318 8.787 12.18 10.3035 13.6973Z"
      fill="#606B8B"
    />
  </svg>
);
